import React, { useEffect, useState } from "react";
import { Controller } from "react-hook-form";
import {
  TextField,
  InputAdornment,
  Autocomplete,
  FormControl,
  FormHelperText,
  RadioGroup,
  FormControlLabel,
  Radio,
  Switch,
  Chip,
  InputLabel,
  Select,
  MenuItem,
  Popper,
} from "@mui/material";
import { StarSymbol } from "../../../Style";
import { createFilterOptions } from "@mui/material/Autocomplete";

import RestrictedDatePicker from "../../common/components/DatePicker";
import {
  DatePicker,
  LocalizationProvider,
  TimePicker,
} from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";

const ControlledTextInputField = ({
  name,
  control,
  defaultValue = "",
  rules = {},
  label = "",
  type = "text",
  placeholder = "",
  switchValue = false,
  fullWidth = true,
  error,
  instantBooking = false,
  multiple = false,
  helperText,
  show,
  size,
  module,
  disabled = false,
  value,
  adultIndex,
  childIndex,
  infantIndex,
  setValue,
  onChange,
  base,
  startAdornment = null,
  endAdornment = null,
  InputProps = {},
  InputLabelProps = { shrink: true },
  options = null, // Pass an array of options for Autocomplete
  getOptionLabel = (option) => option, // Function to map options to display values
  // For Autocomplete
  radioOptions = [], // For RadioGroup
  multiline = false,
  rows = 1,
  airportName="",
  onBlur,
  accept,
}) => {
  const [fileName, setFileName] = useState("");
const airportNameRef = React.useRef("");
const filterOptions = createFilterOptions({
  stringify: (option) => option.label, // filter based on label
});

 
  console.log("airportName updated:", airportNameRef.current);

useEffect(() => {
  airportNameRef.current = airportName || "";

}, [airportName]);
  return (

    <Controller
      name={name}
      control={control}
      defaultValue={defaultValue}
      shouldUnregister={false}
      rules={rules} // Pass the rules to the Controller
      render={({ field }) => {
        if (type === "textarea") {
          return (
            <TextField
              {...field}
              label={label}
              placeholder={placeholder}
              fullWidth={fullWidth}
              error={!!error}
              multiline={true}
              rows={rows}
              size={size}
              autoComplete="new-password"
              helperText={helperText}
              InputProps={{
                startAdornment: startAdornment && (
                  <InputAdornment position="start">
                    {startAdornment}
                  </InputAdornment>
                ),
                endAdornment: endAdornment && (
                  <InputAdornment position="end">{endAdornment}</InputAdornment>
                ),
                ...InputProps,
              }}
              InputLabelProps={InputLabelProps}
              onBlur={(e) => {
                field.onBlur();
                if (typeof onBlur === "function") {
                  onBlur(e);
                }
              }}
              sx={{
                "& .MuiOutlinedInput-root": {
                  "& textarea": {
                    overflowY: "scroll !important",
                    height: "150px !important",
                    maxHeight: "150px !important",
                    scrollbarWidth: "thin",
                    "&::-webkit-scrollbar": {
                      width: "8px",
                    },
                    "&::-webkit-scrollbar-thumb": {
                      backgroundColor: "#888",
                      borderRadius: "4px",
                    },
                    "&::-webkit-scrollbar-track": {
                      backgroundColor: "#f1f1f1",
                    },
                  },
                },
              }}
            />
          );
        }

        if (type === "file") {
          return (
            <FormControl fullWidth error={!!error}>
              <TextField
                type="file"
                label={label}
                error={!!error}
                helperText={helperText}
                disabled={disabled}
                InputLabelProps={InputLabelProps}
                onChange={(e) => {
                  const files = e.target.files;
                  if (files && files.length > 0) {
                    setFileName(files[0].name);
                    field.onChange(files);
                  }
                }}
                InputProps={{
                  startAdornment: startAdornment && (
                    <InputAdornment position="start">
                      {startAdornment}
                    </InputAdornment>
                  ),
                  endAdornment: fileName && (
                    <InputAdornment position="end">
                      <span style={{ marginRight: "8px" }}>{fileName}</span>
                    </InputAdornment>
                  ),
                  inputProps: {
                    accept: accept || ".pdf,.doc,.docx",
                  },
                }}
                onBlur={(e) => {
                  field.onBlur();
                  if (typeof onBlur === "function") {
                    onBlur(e);
                  }
                }}
              />
            </FormControl>
          );
        }
        // Handle RadioGroup for Gender or similar inputs
        if (type === "radio" && radioOptions.length > 0) {
          return (
            <FormControl fullWidth>
              <FormHelperText>{label}</FormHelperText>
              <RadioGroup
                {...field}
                row
                sx={{
                  gap: {
                    xs: 0, // Adjust gap for responsiveness
                    sm: 0,
                    md: 0,
                    lg: 1,
                    xl: 1,
                  },
                }}
                onChange={(e) => field.onChange(e)}
              >
                {radioOptions.map((option) => (
                  <FormControlLabel
                    key={option.value}
                    value={option.value}
                    control={<Radio />}
                    label={option.label}
                  />
                ))}
              </RadioGroup>
              <FormHelperText>
                <StarSymbol> {helperText}</StarSymbol>
              </FormHelperText>
            </FormControl>
          );
        }

        if (type === "datebooking") {
          return (
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                {...field}
                label={label}
                size={size}
                value={field.value ? dayjs(field.value, "DD-MM-YYYY") : null}
                format="DD-MM-YYYY"
                slotProps={{
                  textField: {
                    error: Boolean(error),
                    fullWidth,
                    InputLabelProps,
                    helperText: helperText || " ",
                  },
                }}
                onChange={(newValue) => {
                  const formattedDate = newValue
                    ? dayjs(newValue).format("DD-MM-YYYY")
                    : null;
                  field.onChange(formattedDate);
                }}
                shouldDisableDate={(date) => {
                  const today = dayjs().startOf("day");
                  const twoDaysAhead = instantBooking
                    ? today
                    : today.add(airportNameRef.current === "Mumbai"?2:1, "day").startOf("day");
                  return date.isBefore(twoDaysAhead, "day");
                }}
              />
            </LocalizationProvider>
          );
        }
        if (type === "dob") {
          return (
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                {...field}
                label={label}
                size={size}
                disabled={disabled}
                value={field.value ? dayjs(field.value, "DD-MM-YYYY") : null}
                disableFuture
                format="DD-MM-YYYY" // Display format
                placeholder="DD-MM-YYYY"
                slotProps={{
                  textField: {
                    error: Boolean(error),
                    fullWidth,
                    InputLabelProps,
                    helperText: helperText || " ",
                  },
                }}
                onChange={(newValue) => {
                  if (newValue) {
                    // For UI display - keep as DD-MM-YYYY
                    const displayFormat = newValue.format("DD-MM-YYYY");
                    // Store the value in the form
                    field.onChange(displayFormat);
                  } else {
                    field.onChange(null);
                  }
                }}
              />
            </LocalizationProvider>
          );
        }

     if (multiple) {
  return (
    <Autocomplete
      {...field}
      multiple
      id="tags-outlined"
      options={options || []}
      value={field.value || []}
      getOptionLabel={(option) =>
        typeof option === "string" ? option : option?.label || ""
      }
      isOptionEqualToValue={(option, value) => option.value === value?.value}
      filterOptions={filterOptions}
      filterSelectedOptions
      componentsProps={{
        input: {
          autoComplete: "new-password",
        },
      }}
      disabled={disabled}
      onChange={(_, values) => {
        field.onChange(values || []);
        if (typeof onChange === "function") {
          onChange(values);
        }
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          placeholder={placeholder}
          fullWidth={fullWidth}
          error={!!error}
          size={size}
            helperText={helperText}
            InputLabelProps={InputLabelProps}
            inputProps={{
              ...params.inputProps,
              autoComplete: "new-password",
            }}
            onBlur={(e) => {
              field.onBlur();
              if (typeof onBlur === "function") {
                onBlur(e);
              }
            }}
          />
      )}
    />
  );
}

        // In your ControlledTextInputField component, replace the country_code handling section with this:

        if (
          (options && name === "country_code") ||
          name.includes("country_code")
        ) {
          return (
            <Autocomplete
              {...field}
              options={options || []}
              getOptionLabel={(option) => (option ? option.label || "" : "")}
              value={field.value || null} // Ensure proper value handling
              onChange={(_, value) => {
                field.onChange(value || null); // Allow null for validation to work
                if (typeof onChange === "function") {
                  onChange(value);
                }
              }}
              componentsProps={{
                input: {
                  autoComplete: "new-password",
                },
              }}
              PopperComponent={(props) => (
                <Popper {...props} sx={{ minWidth: 200 }} />
              )}
              // Remove disableClearable to allow proper required validation
              renderInput={(params) => (
                <TextField
                  {...params}
                  label={label}
                  placeholder={placeholder}
                  fullWidth={fullWidth}
                  error={!!error}
                  size={size}
                  autoComplete="new-password"
                  helperText={helperText}
                  InputProps={{
                    ...params.InputProps,
                    startAdornment: startAdornment && (
                      <InputAdornment position="start">
                        {startAdornment}
                      </InputAdornment>
                    ),
                    endAdornment: (
                      <>
                        {params.InputProps.endAdornment}
                        {endAdornment}
                      </>
                    ),
                    ...InputProps,
                  }}
                  InputLabelProps={InputLabelProps}
                  inputProps={{
                    ...params.inputProps,
                    autoComplete: "new-password",
                  }}
                  onBlur={(e) => {
                    field.onBlur();
                    if (typeof onBlur === "function") {
                      onBlur(e);
                    }
                  }}
                />
              )}
            />
          );
        }
        if (options) {
          return (
            <Autocomplete
              {...field}
              options={options || []}
              getOptionLabel={(option) => (option ? option.label || "" : "")}
              disabled={disabled}
              componentsProps={{
                input: {
                  autoComplete: "new-password", // ✅ Proper override here
                },
              }}
              onChange={(_, value) => {
                field.onChange(value || "");
                if (typeof onChange === "function") {
                  onChange(value); // Call the custom onChange handler
                }
                if (name === "arrival_departure_type" && module === "booking") {
                  setValue("service_type", "");
                }
                if (name === "service_type" && module === "booking") {
                  setValue("arrival_plan", "");
                  setValue("departure_plan", "");
                  setValue("transit_plan", "");
                }
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  value={value}
                  label={label}
                  placeholder={placeholder}
                  fullWidth={fullWidth}
                  error={!!error}
                  size={size}
                  helperText={helperText}
                  InputProps={{
                    ...params.InputProps,
                    startAdornment: startAdornment && (
                      <InputAdornment position="start">
                        {startAdornment}
                      </InputAdornment>
                    ),
                    endAdornment: (
                      <>
                        {params.InputProps.endAdornment}
                        {endAdornment}
                      </>
                    ),
                    ...InputProps,
                  }}
                  InputLabelProps={InputLabelProps}
                  inputProps={{
                    ...params.inputProps,
                    autoComplete: "new-password", // still include this
                  }}
                  onBlur={(e) => {
                    field.onBlur();
                    if (typeof onBlur === "function") {
                      onBlur(e);
                    }
                  }}
                />
              )}
            />
          );
        }

        if (type === "switch") {
          return (
            <FormControl fullWidth>
              <FormControlLabel
                control={
                  <Switch
                    {...field}
                    checked={field.value || false}
                    onChange={(e) => {
                      const checked = e.target.checked;
                      field.onChange(checked);

                      // Reset values when switching
                      if (checked) {
                        setValue(`adults.${adultIndex}.aadhar_number`, "");
                        setValue(`children.${childIndex}.aadhar_number`, "");
                        setValue(`infants.${infantIndex}.aadhar_number`, "");

                        // Reset Aadhar
                      } else {
                        setValue(`adults.${adultIndex}.passport_number`, "");
                        setValue(`children.${childIndex}.passport_number`, "");
                        setValue(`infants.${infantIndex}.passport_number`, "");
                        // Reset Passport
                      }
                    }}
                  />
                }
                label={field.value ? "Use Aadhar" : "Use Passport"}
              />
            </FormControl>
          );
        }

        if (base === "switch" && label === "Passport Number") {
          return (
            <TextField
              {...field}
              label={label}
              placeholder={placeholder}
              fullWidth={fullWidth}
              error={!!error}
              type={type}
              autoComplete="new-password"
              size={size}
              disabled={!show}
              helperText={helperText}
              InputProps={{
                startAdornment: startAdornment && (
                  <InputAdornment position="start">
                    {startAdornment}
                  </InputAdornment>
                ),
                endAdornment: endAdornment && (
                  <InputAdornment position="end">{endAdornment}</InputAdornment>
                ),

                ...InputProps,
              }}
              InputLabelProps={InputLabelProps}
            />
          );
        }
        if (base === "switch" && label === "Aadhar Number") {
          return (
            <TextField
              {...field}
              label={label}
              placeholder={placeholder}
              fullWidth={fullWidth}
              error={!!error}
              type={type}
              autoComplete="new-password"
              size={size}
              disabled={show}
              helperText={helperText}
              InputProps={{
                startAdornment: startAdornment && (
                  <InputAdornment position="start">
                    {startAdornment}
                  </InputAdornment>
                ),
                endAdornment: endAdornment && (
                  <InputAdornment position="end">{endAdornment}</InputAdornment>
                ),

                ...InputProps,
              }}
              InputLabelProps={InputLabelProps}
            />
          );
        }
        if (base == null) {
          return (
            <TextField
              {...field}
              label={label}
              placeholder={placeholder}
              fullWidth={fullWidth}
              error={!!error}
              type={type}
              autoComplete="new-password"
              disabled={disabled}
              size={size}
              helperText={helperText}
              multiline={multiline}
              rows={rows}
              sx={{
                "& .MuiInputBase-input": {
                  color: "black",
                },
                "& .MuiOutlinedInput-input.Mui-disabled": {
                  color: "black",
                  WebkitTextFillColor: "black",
                },
                ...(multiline && {
                  "& .MuiOutlinedInput-root": {
                    "& textarea": {
                      overflowY: "scroll !important",
                      height: "80px !important",
                      maxHeight: "300px !important",
                      scrollbarWidth: "thin",
                      "&::-webkit-scrollbar": {
                        width: "8px",
                      },
                      "&::-webkit-scrollbar-thumb": {
                        backgroundColor: "#888",
                        borderRadius: "4px",
                      },
                      "&::-webkit-scrollbar-track": {
                        backgroundColor: "#f1f1f1",
                      },
                    },
                  },
                }),
              }}
              InputProps={{
                startAdornment: startAdornment && (
                  <InputAdornment position="start">
                    {startAdornment}
                  </InputAdornment>
                ),
                endAdornment: endAdornment && (
                  <InputAdornment position="end">{endAdornment}</InputAdornment>
                ),

                ...InputProps,
              }}
              InputLabelProps={InputLabelProps}
              onBlur={(e) => {
                field.onBlur();
                if (typeof onBlur === "function") {
                  onBlur(e);
                }
              }}
            />
          );
        }
      }}
    />
  );
};

export default ControlledTextInputField;
